<template>
  <div>
    <!-- 筛选 -->
    <my-search
      timeScreen
      :searchParams="searchParams"
      :[dynamicData]="2"
      @searchEvent="searchEvent"
    />

    <!-- 列表 -->
    <my-table
      isSelection
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
      @click.native="testNative"
      @handleSelectionChange="handleSelectionChange"
    />
    <!-- 分页器 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />

    <!-- 添加、修改组件 -->
    <my-dialog
      :isDialogShow.sync="isDialogShow"
      :operTitle="operTitle"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :rules="rules"
      :loading="loading"
      @submitForm="submitForm"
      @hook:mounted="doSomeThing"
    />

    <!-- 详情组件 -->
    <my-dialog-detail
      :isDialogDetailShow.sync="isDialogDetailShow"
      :operForm="operForm"
      :operFormArr="operFormArr"
      :closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import _exportMethods from "@/utils/excel";
import mixins from "@/mixins/common";
import { workOrderList } from "@/network/workManage/workOrder";
export default {
  mixins: [mixins],
  provide() {
    return {
      importType: "role",
      initData: this.getInitData,
    };
  },
  watch: {
    tableData: {
      handler(val) {
        // console.log(val);
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      /**
       * 当前头部数据列
       * 不需要响应式的数据可以进行冻结，Vue实例不会对数据再做数据劫持(getter、setter转换),可以提高Vue渲染性能
       * 不可以向当前对象添加、更新、删除属性。如需修改可以将变量的引用替换掉
       */
      tableHeader: Object.freeze([
        
		{
		  name: "登陆名",
		  prop: "userName",
		},
		
        {
          name: "标签",
          prop: "tagNames",
        },
        {
          name: "工单状态",
          prop: "status",
        },
        {
          name: "创建时间",
          prop: "createTime",
        },
      ]),
      //编辑时文本框所需参数
      operFormArr: [
        {
          name: "contactUs",
          label: "联系我们",
        },
        {
          name: "enterpriseMailbox",
          label: "企业邮箱",
        },
        {
          name: "copyrightNotice",
          label: "版权声明",
        },
        {
          name: "briefIntroduction",
          label: "简介",
          type: "textarea",
        },
      ],
      //编辑双向绑定值
      operForm: {
        id: "",
        contactUs: "",
        enterpriseMailbox: "",
        copyrightNotice: "",
        briefIntroduction: "",
      },
      //搜索参数
      searchParams: {
        timeOptions: [],
      },
      // rules表单验证
      rules: {
        contactUs: [
          {
            required: true,
            message: "请输入联系我们",
            trigger: "blur",
          },
        ],
        enterpriseMailbox: [
          {
            required: true,
            message: "请输入企业邮箱",
            trigger: "blur",
          },
        ],
        copyrightNotice: [
          {
            required: true,
            message: "请输入版权声明",
            trigger: "blur",
          },
        ],
        briefIntroduction: [
          {
            required: true,
            message: "请输入简介",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    getInitData(isSearch) {
      let timeOptions = this.searchParams.timeOptions; //日期参数
      let params = {
        data: {
          role: this.searchParams.textRole,
          roleName: this.searchParams.textRoleName,
        },
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      };
      workOrderList(params).then((e) => {
        this.loading = false;
        let { code, data } = e.data;
        if (code == 200) {
          //   console.log(data);
          this.tableData = data.records;
          this.pageParams.total = data.total;
          if (isSearch) this.pageParams.currentPage = 1;
        }
      });
    },
    //添加、编辑
    submitForm(valid) {
      if (valid) {
        //根据类型不同调用不同的操作接口
        let interType = this.operTitle ? addRole : editAbout;
        interType(this.operForm).then((e) => {
          let { code, data, msg } = e.data;
          if (code == 200) {
            this.isDialogShow = false;
            this.loading = false;
            this.getInitData();
            this.$message.success("操作成功");
          } else {
            this.$message.error("操作失败");
          }
        });
      } else {
        return false;
      }
    },
    //搜索事件
    searchEvent() {
      this.getInitData(true);
    },
    //添加事件
    addEvent() {
      this.isDialogShow = true;
      this.operTitle = true;
      this.operForm = {}; //防止多次添加有上次添加的残留数据
    },
    //详情事件
    detailAbout(item) {
      this.isDialogDetailShow = true;
      this.operForm = item;
    },
    //编辑事件
    editAbout(item) {
      this.isDialogShow = true;
      this.operTitle = false;
      this.operForm = {
        id: item.id,
        contactUs: item.contactUs,
        enterpriseMailbox: item.enterpriseMailbox,
        copyrightNotice: item.copyrightNotice,
        briefIntroduction: item.briefIntroduction,
      };
    },
    //详情函数式组件关闭弹框
    closeDialog() {
      this.isDialogDetailShow = false;
    },
    //在子组件上监听点击事件，如果不加.native的话，Vue会以为是自定义的事件，这样的话必须得在子组件发送一个emit事件触发才可以
    testNative() {
      // console.log("native click");
    },
    //在父组件里监听到子组件的生命周期 @hook:mounted="doSomething"
    doSomeThing() {
      // console.log('父组件监听到 mounted 钩子函数 ...');
    },
  },
};
</script>

<style scoped>
</style>

 
 